import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDjYnQ2BImYCPaV7Ybs8X0pJexAr7cYiJM",
  // authDomain must point to Firebase Hosting (firebaseapp.com), NOT your
  // custom Vercel domain. Firebase's /__/auth/handler only exists on Firebase
  // Hosting — routing it through Vercel just loads index.html and breaks OAuth.
  // Both custom domains still work; add them to Firebase Auth → Authorized Domains.
  authDomain: "cursivo.iitiimcareers.in",
  projectId: "cv-editor-pro",
  storageBucket: "cv-editor-pro.firebasestorage.app",
  messagingSenderId: "136122249543",
  appId: "1:136122249543:web:0874589f8d0d73e04b5c62"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
